export default {
  jobNumber: 'Numer zadania',
  loaded: 'Załadowany',
  process: 'Przepis',
  processStartTime: 'Czas rozpoczęcia procesu',
  stageName: 'Imię sceniczne',
  stageNumber: 'Numer etapu',
  stageTime: 'Czas na scenę',
  status: 'Status',
  systemName: 'Nazwa systemu',
};
